import React from 'react';
import {
  SimpleForm,
  SaveButton,
  required,
  ReferenceInput,
  TextInput,
  AutocompleteInput,
  Toolbar,
} from 'react-admin';
import { CreateBody } from '../../components/CreateBody';
import { suggestionsContainerProps} from '../../utils';

export const ConsentBannerCreate = (props) => (
  <CreateBody  {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>

      <ReferenceInput label="Account" source="account" reference="accounts" validate={required()}
        filterToQuery={searchText => ({ name: searchText })}>
        <AutocompleteInput options={{suggestionsContainerProps}} optionText="name" />
      </ReferenceInput>

      <TextInput source="name" validate={required()} />

      <TextInput multiline source="html" options={{ maxRows: "10" }} />

      <TextInput multiline source="css" options={{ maxRows: "10" }} />

      <TextInput multiline source="js" options={{ maxRows: "10" }} />

      <TextInput source="displayBannerFunctionName" />

      <TextInput source="hideBannerFunctionName" />
    </SimpleForm>
  </CreateBody>
);

const CustomToolbar = props => (
  <Toolbar {...props} >
    <SaveButton className="consent-banner-create-save-button"/>
  </Toolbar>
);
